{
	"meta": {
		"title": "UpSquad — Your branded community app, live in 72 hours",
		"description": "UpSquad gives your organization a branded AI-powered learning and networking community — with a fully branded mobile app in the App Store within 72 hours."
	},
	"hero": {
		"eyebrow": "From signup to App Store in 72 hours",
		"title_1": "Your community.",
		"title_2": "Your branded app.",
		"title_3": "Live in 72 hours.",
		"subtitle": "Run a thriving learning and networking community with AI that actually helps — under your own brand and domain. No developers. No agencies. No glue code.",
		"cta_primary": "Sign up free",
		"cta_secondary": "Book a demo",
		"bullet_1": "Free 14-day trial",
		"bullet_2": "No credit card needed",
		"bullet_3": "Branded mobile app in 72 hours",
		"frames": {
			"events": "Events tab of the mobile app",
			"feed": "Home feed of the mobile app",
			"clips": "Community clips tab of the mobile app"
		}
	},
	"trusted_by": {
		"eyebrow": "Trusted by leading organizations across the United States"
	},
	"demo": {
		"eyebrow": "Interactive demo",
		"title": "Click around.",
		"title_accent": "It's the real product.",
		"subtitle": "Navigate UpSquad like one of your members would — feed, members, messaging, meetings, events, AI insights, and settings. No signup needed.",
		"footnote": "Live demo · You're touching real components",
		"footnote_cta": "Try it free",
		"live_badge": "Live demo",
		"nav_label": "Product demo navigation",
		"tabs": {
			"home": {
				"label": "Home",
				"hint": "Posts, polls, videos — your community feed in one place."
			},
			"members": {
				"label": "Members",
				"hint": "A searchable directory with last-active, groups, and presence."
			},
			"messages": {
				"label": "Messages",
				"hint": "Group channels and DMs replace the scattered tools you use today."
			},
			"meetings": {
				"label": "Meetings",
				"hint": "1:1s and group meetings, with AI agendas built in."
			},
			"events": {
				"label": "Events",
				"hint": "Free or paid events with RSVPs and attendance tracking."
			},
			"ai": {
				"label": "AI Insights",
				"hint": "Ask anything about your community and get a real answer."
			},
			"settings": {
				"label": "Community",
				"hint": "Brand it, theme it, make it yours — every screen re-tints live."
			}
		}
	},
	"unified": {
		"eyebrow": "Powered by AI",
		"title": "One platform.",
		"title_accent": "All your tools, unified.",
		"subtitle": "Stop juggling ten disconnected apps. UpSquad pulls messaging, events, meetings, learning and member data into a single AI-powered home for your community.",
		"stat_1": {
			"title": "Replace ten-plus tools",
			"body": "Messaging, events, meetings, learning — every workflow native, every member in one place."
		},
		"stat_2": {
			"title": "AI that actually helps",
			"body": "Insights, matchmaking, and auto-summaries built in from day one. No prompt engineering required."
		},
		"stat_3": {
			"title": "One source of truth",
			"body": "Member data, activity, and outcomes — unified, always live, ready to share with your board."
		},
		"metrics": {
			"tools": {
				"label": "tools replaced"
			},
			"ai": {
				"label": "AI assistants built in"
			},
			"truth": {
				"label": "source of truth"
			},
			"launch": {
				"title": "Seventy-two hours to the App Store",
				"body": "Premium customers get a fully branded iOS and Android app, submitted and published by us.",
				"label": "hours to launch"
			},
			"brand": {
				"title": "Under your brand",
				"body": "Your logo, name, colors and domain on every screen. Members see your organization, not ours.",
				"label": "under your brand"
			}
		}
	},
	"branded": {
		"eyebrow": "Premium feature",
		"title_1": "Your brand. Your app.",
		"title_accent": "In the App Store in 72 hours.",
		"subtitle": "Premium customers get a fully branded iOS and Android app — live in three days. Pick a theme below and watch every screen re-tint.",
		"theme_label": "Live theme switcher",
		"frames": {
			"events": "Branded events screen, {{theme}} theme",
			"feed": "Branded mobile app preview, {{theme}} theme",
			"members": "Branded members screen, {{theme}} theme"
		},
		"benefit_1": {
			"title": "Fully branded",
			"body": "Your logo, name and colors throughout the entire app. Members see you, not us."
		},
		"benefit_2": {
			"title": "Seventy-two-hour launch",
			"body": "From signup to App Store listing — we handle every step of the submission."
		},
		"benefit_3": {
			"title": "Auto-updated",
			"body": "New features ship to your members automatically. Zero developers, zero maintenance."
		},
		"cta": "Get your branded app"
	},
	"ai_insights": {
		"eyebrow": "Ask anything",
		"title": "Stop guessing.",
		"title_accent": "Start knowing.",
		"subtitle": "Every week UpSquad's AI scans your community — who's engaged, who's drifting, what events drove the most connection, and what to do next.",
		"url": "cohort-hub.upsquad.us/ai",
		"frame": "AI Insights screen of the web app",
		"feature_1": {
			"title": "Weekly engagement reports",
			"body": "Delivered to your inbox automatically — no dashboards to wrangle."
		},
		"feature_2": {
			"title": "Actionable recommendations",
			"body": "Specific steps to re-engage at-risk members, with templates ready to send."
		},
		"feature_3": {
			"title": "Match AI",
			"body": "Connects members who should meet based on goals, activity and outcomes."
		}
	},
	"getting_started": {
		"eyebrow": "Getting started",
		"title": "Your community,",
		"title_accent": "live in minutes.",
		"step_1": {
			"title": "Sign up free",
			"body": "Create your UpSquad account and set up a branded community space in under ten minutes."
		},
		"step_2": {
			"title": "Invite your members",
			"body": "Share your custom invite link (yourorg.upsquad.us) and onboard your team in one click."
		},
		"step_3": {
			"title": "Grow with AI",
			"body": "Let UpSquad surface insights, connect the right members, and run your programs — while you focus on people."
		}
	},
	"pricing_teaser": {
		"title": "Free to start.",
		"title_accent": "Built to scale.",
		"subtitle": "Start free with no credit card. Upgrade when your community is ready to grow.",
		"free": {
			"name": "Free",
			"price": "$0",
			"body": "Up to 25 members · Core features · 14-day trial",
			"cta": "Start free",
			"features": [
				"Up to 25 members",
				"Core feed and DMs",
				"Custom community URL"
			]
		},
		"pro": {
			"name": "Pro",
			"price": "$9",
			"period": "/user/mo",
			"ribbon": "Most popular",
			"body": "Everything in Free + AI · unlimited members · paid events",
			"cta": "Start Pro trial",
			"features": [
				"Unlimited members",
				"AI Insights + Match AI",
				"Paid events and analytics"
			]
		},
		"premium": {
			"name": "Premium",
			"price": "Custom",
			"body": "Everything in Pro + branded mobile app in 72 hours",
			"cta": "Talk to sales",
			"features": [
				"Branded iOS + Android app",
				"Dedicated onboarding",
				"SLA-backed uptime"
			]
		},
		"see_all": "See all plans"
	},
	"final_cta": {
		"title": "Ready to launch",
		"title_accent": "your community?",
		"body": "Join organizations across the US who run their programs on UpSquad. Start free — upgrade when you're ready.",
		"cta_primary": "Sign up free",
		"cta_secondary": "Book a demo",
		"footnote": "No credit card · 14 days free · Cancel anytime"
	}
}
